import React, { useDebugValue, useEffect, useMemo, useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import SelectList from "../../../components/common/SelectList";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { Input, Select } from "antd";
import TextArea from "antd/es/input/TextArea";

const EditStandardForm = ({ onOpen, onClose, data, onSave }) => {
  const [selectedForms, setSelectedForms] = useState([]);
  const [formName, setFormName] = useState(data.title);
  // const [status, setStatus] = useState(data.status);
  const [description, setDescription] = useState(data.description);
  const [errors, setErrors] = useState({});
  const selectedFormId = data._id;
  const selectFormList = useMemo(
    () => [
      { label: "EMPLOYEE", value: "employee" },
      { label: "VENDOR", value: "vendor" },
      {
        label: "USER",
        value: "user"
      },
      // { label: "SUB ADMIN", value: "sub_admin" },
    ],
    []
  );

  const handleSelectedFormChange = (value) => {
    setSelectedForms((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleSave = async () => {
    const newErrors = {};

    if (!formName.trim()) {
      newErrors.formName = "Form name is required";
    }

    if (!description.trim()) {
      newErrors.description = "Description is required";
    }

    // if (!status.trim()) {
    //   newErrors.status = "Description is required";
    // }
    if (selectedForms.length === 0) {
      newErrors.role_type = "At least one role type must be selected";
    }

    setErrors(newErrors);

    // If there are any errors, don't proceed
    if (Object.keys(newErrors).length > 0) return;

    const formData = {
      title: formName,
      description,
      // status,
      role_type: selectedForms
    };

    await onSave(formData, selectedFormId);
  };

  const handleCancel = () => {
    setSelectedForms([]);
    onClose();
  };

  useEffect(() => {
    if (data) {
      setFormName(data.title || "");
      setDescription(data.description || "");
      setSelectedForms(data.role_type || []);
      // setStatus(data.status || "");
    }
  }, [data]);

  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className=" text-xl text-[#06513D]">Edit Form</h3>
        </div>
        <div className=" mt-10 border px-4 rounded-lg">
          <div className="mx-8 my-8">
            <Input
              type="primary"
              value={formName}
              onChange={(e) => setFormName(e.target.value)}
              placeholder="Form Name"
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "10px"
              }}
              className="text-base font-light h-14"
            />
            {errors.formName && (
              <p className="text-red-500 text-sm mt-1">{errors.formName}</p>
            )}
            <TextArea
              type="primary"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description"
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "10px"
              }}
              className="text-base font-light h-14 mt-5"
            />
            {errors.description && (
              <p className="text-red-500 text-sm mt-1">{errors.description}</p>
            )}
            {/* <div className="mt-5">
              <Select
                value={status || undefined}
                onChange={(value) => setStatus(value)}
                placeholder="Status"
                className="h-14 rounded-lg w-full"
                options={[
                  { label: "Approved", value: "Approved" },
                  { label: "Inactive", value: "Inactive" },
                  { label: "Sent for Approval", value: "Sent for Approval" },
                  { label: "Draft", value: "Draft" }
                ]}
              />
            </div>
            {errors.status && (
              <p className="text-red-500 text-sm mt-1">{errors.status}</p>
            )} */}
            <p className=" text-lg mt-4  text-[#06513D]">Role Type</p>
            <div className=" mt-5 border px-4 rounded-lg">
              <SelectList
                list={selectFormList}
                paddingRequired={false}
                selecteditems={selectedForms}
                onChange={handleSelectedFormChange}
                selectionType="checkbox"
              />
              {errors.role_type && (
                <p className="text-red-500 text-sm mt-1">{errors.role_type}</p>
              )}
            </div>

            <div className="flex justify-center gap-4 py-6">
              <CustomButton
                buttonType="primary"
                variant="cancel"
                buttonText="Cancel"
                className="text-base font-normal h-[50px] w-[200px]"
                onClick={handleCancel}
              />
              <CustomButton
                buttonType="primary"
                variant="ok"
                buttonText="Save"
                className="text-base font-normal h-[50px] w-[200px]"
                onClick={handleSave}
              />
            </div>
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default EditStandardForm;
